import { IGameSummary } from '@soposopo/sopo-models';

export interface GameHistoryState {
    gameHistories: {[key: string]:  GameHistory };
}

export interface GameHistory {
    activeTab: string;
    historyIDs: string[];
    gameHistories: IHandHistories;
    historyIndex: number;
}

export interface GameDetails {
    historyID: string;
    actions: HandDetailsActions;
    communityCards: string[];
    pots: HandDetailsPots;
    showdownPlayers: ShowdownDetails[];
}

export interface ShowdownDetails {
    playerId: string;
    playerName: string;
    bestCards: string[] | null;
    hand: PlayerCard[];
    shortHandDescription: string | null;
    positionName: string | null;
    profit: number;
}

export const INITIAL_SHOWDOWNPLAYERS_DETAILS: ShowdownDetails = {
    playerId: '',
    playerName: '',
    bestCards: [],
    hand: [],
    shortHandDescription: '',
    positionName: '',
    profit: 0
}

export interface PlayerCard {
    card: string;
    revealed: boolean;
    isRevealRequested: boolean;
}

export const INITIAL_PLAYER_CARD: PlayerCard = {
    card: '', 
    revealed: false,
    isRevealRequested: false
}

export interface DetailsActionPlayer { 
    playerID: string;
    playerName: string;
    positionName: string | null;
}

export const INITIAL_DETAILS_ACTION_PLAYER: DetailsActionPlayer = {
    playerID: '',
    playerName: '',
    positionName: '',
}

export interface DetailsActionType {
    action: string;
    player: DetailsActionPlayer;
    paid?: number;
    stack?: number;
    wagerToCall?: number;
    raiseBy?: number;
    raiseTo?: number;
    runMultipleAnswer?: boolean;
    runMultipleSet?: number;
}

export const INITIAL_DETAILS_ACTION_TYPE: DetailsActionType = {
    action: '',
    player: INITIAL_DETAILS_ACTION_PLAYER, 
}

export interface HandDetailsActions {
    PREDEAL: DetailsActionType[];
    PREFLOP: DetailsActionType[];
    FLOP: DetailsActionType[];
    TURN: DetailsActionType[];
    RIVER: DetailsActionType[];
}

export const INITIAL_HAND_DETAILS_ACTIONS: HandDetailsActions = {
    PREDEAL: [],
    PREFLOP: [],
    FLOP: [],
    TURN: [],
    RIVER: []
}

export interface HandDetailsPots {
    PREDEAL?: number[];
    PREFLOP?: number[];
    FLOP?: number[];
    TURN?: number[];
    RIVER?: number[];
}

export const INITIAL_HAND_DETAILS_POTS: HandDetailsPots = {
    PREDEAL: [],
    PREFLOP: [],
    FLOP: [],
    TURN: [],
    RIVER: []
}

export interface HandDetails {
    actions: HandDetailsActions;
    communityCards: string[][];
    pots: HandDetailsPots;
    showdownPlayersArray: ShowdownDetails[][];
}

export const INITIAL_HAND_DETAILS: HandDetails = {
    actions: INITIAL_HAND_DETAILS_ACTIONS,
    communityCards: [],
    pots: INITIAL_HAND_DETAILS_POTS,
    showdownPlayersArray: []
}

export interface IHandHistories {
    [handID: string]: {
        tableID: string;
        summary: IGameSummary;
        events: any[];
        details: HandDetails;
    };
}

export const INIT_GAME_HISTORY: GameHistory = {
    activeTab: 'Summary',
    historyIDs: [],
    gameHistories: {},
    historyIndex: -1,
};

export const INIT_GAME_HISTORY_STATE: GameHistoryState = {
    gameHistories: {}
}

export const MAX_DISPLAYABLE_HISTORY_COUNT = 30;
